import { useContext } from "react"
import { SquaresPlusIcon } from "@heroicons/react/24/outline"
import { MultiContext } from "~/contexts/MultiContext"
import { PlainFrame } from "~/components/Single/Frame"

const colorClasses = `text-neutral-700 transition ease-in-out group-hover:text-neutral-500`

export function Add() {
  const { firstAvailablePosition, setIsCommandMenuOpen, setSelectedCommandMenuOption } =
    useContext(MultiContext)
  const position = firstAvailablePosition()

  const onClick = () => {
    setIsCommandMenuOpen(true)
    setSelectedCommandMenuOption("add")
  }

  return (
    <PlainFrame position={position} overrides={{ frameClasses: "!bg-neutral-800" }}>
      <div className="group relative block flex h-full w-full items-center justify-center rounded-lg border border-dashed border-neutral-800 p-12 transition ease-in-out hover:border-2 hover:border-neutral-500">
        <button type="button" onClick={onClick}>
          <SquaresPlusIcon className={`mx-auto h-12 w-12 ${colorClasses}`} />
          <span className={`mt-2 block text-sm font-semibold ${colorClasses}`}>
            Add a new video
          </span>
        </button>
      </div>
    </PlainFrame>
  )
}
